/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFlagFill: {
  name: 'flag-fill';
  data: string;
} = {
  name: 'flag-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.809 15.152c-.8-.065-1.377.038-1.809.317V20a1 1 0 1 1-2 0V5a1 1 0 0 1 .293-.707c1.044-1.044 2.395-1.238 3.68-1.133 1.2.1 2.518.476 3.745.828l.182.051c1.33.38 2.575.723 3.72.808 1.127.084 2.042-.093 2.78-.646A1 1 0 0 1 20 5v10a1 1 0 0 1-.4.8c-1.262.946-2.722 1.145-4.127 1.04-1.385-.102-2.827-.509-4.123-.879l-.083-.024c-1.312-.375-2.459-.702-3.458-.784Z" fill="currentColor"/></svg>`,
};
